import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";

import authSessionReducer from "@/features/auth/authSessionSlice";
import foundationReducer from "@/features/foundation/foundationSlice";
import onboardingReducer from "@/features/onboarding/onboardingSlice";
import { activeStorePreferenceMiddleware } from "@/features/settings/activeStorePreference";
import activeStoreReducer from "@/features/settings/activeStoreSlice";
import { baseApi } from "@/shared/api/baseApi";

export const store = configureStore({
  reducer: {
    activeStore: activeStoreReducer,
    authSession: authSessionReducer,
    foundation: foundationReducer,
    onboarding: onboardingReducer,
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware, activeStorePreferenceMiddleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
